const norientRouteMap = document.getElementById('norientRouteMap');

if (norientRouteMap) {
	const routeDots = norientRouteMap.querySelectorAll('.route-dot');
	const routeNames = norientRouteMap.querySelectorAll('.route-name');

	routeDots.forEach((routeDot) => {
		const programName = routeDot.dataset.program ? routeDot.dataset.program : null;

		routeDot.addEventListener('click', () => {
			if (document.getElementById(programName)) {
				document
					.getElementById(programName)
					.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
			}
		});
	});
}
